import { ExpandWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Expand')
export class ExpandNodeSchemaProvider extends SchemaProvider<ExpandWorkflowNode> {}
